import { NamingConventionItemType, NamingConventionType } from '@shared/enums';

export interface NamingConventionItem {
  id: number | string;
  namingConventionId: number;
  namingConventionType: NamingConventionType;
  itemType: NamingConventionItemType;
  value: string;
  priority: number;
}
